import { environment } from "@environment";
import { Component, Inject, OnInit } from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";

import { GtmService } from "@app/core/services/analytics/gtm.service";

import { MobileLoginWrapperComponent } from "@app/modules/authentication/components/mobile-components/mobile-login-wrapper/mobile-login-wrapper.component";
import { DesktopLoginWrapperComponent } from "@app/modules/authentication/components/desktop-components/desktop-login-wrapper/desktop-login-wrapper.component";
import { DeviceService } from "@app/core/services/util/device.service";
import { UtilityService } from "@app/core/services/util/utility.service";

@Component({
    selector: "app-agent-offer-intro",
    templateUrl: "./agent-offer-intro.component.html",
    styleUrls: ["./agent-offer-intro.component.scss"],
    standalone: true
})
export class AgentOfferIntroComponent implements OnInit {
    response: any;
    DEPLOY_URL: string;
    isMobile: boolean = false;
    OFFER_URL: string = "/third_party/agent_offer/get_offer";

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialog: MatDialog,
        private gtmService: GtmService,
        private bottomSheet: MatBottomSheet,
        private deviceService: DeviceService,
        private utilityService: UtilityService,
        public dialogRef: MatDialogRef<AgentOfferIntroComponent>
    ) {
        this.DEPLOY_URL = environment.DEPLOY_URL;
        this.isMobile = this.deviceService.isMobile();
        this.gtmService.logEvent("web_analytics", {
            event_action: "new_ordering_flow",
            event_label: "Offer Intro Screen",
            value1: "Opened"
        });
    }

    ngOnInit(): void {
        this.response = this.data.response;
    }

    close(isLoggedIn: boolean = false) {
        this.dialogRef.close(isLoggedIn);
    }

    copyCode(code: string) {
        this.gtmService.logWebAnalyticsEvent("new_ordering_flow", "Offer Intro Screen", "Copy Code: " + code);
        this.utilityService.copyCode(code);
    }

    openSignin() {
        this.gtmService.logWebAnalyticsEvent("new_ordering_flow", "Offer Intro Screen", "Sign In");

        if (this.isMobile) {
            const dialogRef = this.bottomSheet.open(MobileLoginWrapperComponent, {
                panelClass: "bottom-sheet-wrapper"
            });

            dialogRef.afterDismissed().subscribe((authData : { authentication: Boolean }) => {
                if (authData?.authentication) {
                    this.dialogRef.close(true);
                }
            });
        } else {
            const dialogConfig = {
                maxWidth: 420,
                minWidth: 320
            };
            const dialogRef = this.dialog.open(DesktopLoginWrapperComponent, dialogConfig);
            dialogRef.afterClosed().subscribe((authData : { authentication: Boolean }) => {
                if (authData?.authentication) {
                    this.dialogRef.close(true);
                }
            });
        }
    }
}
